import api from "@services/newApi/api";
import type { IUser } from "@features/users";
import type { IActiveHospital } from "./types";

export function setActiveHospitalStorage(
  hospital: IActiveHospital | undefined,
) {
  if (!hospital) {
    sessionStorage.removeItem("h");

    sessionStorage.removeItem("hospital");
    sessionStorage.removeItem("hospitalName");
    sessionStorage.removeItem("permissions");
    localStorage.removeItem("hospital");
    localStorage.removeItem("hospitalName");
    localStorage.removeItem("permissions");
    return;
  }

  sessionStorage.setItem("h", JSON.stringify(hospital));

  hospital.uuid
    ? sessionStorage.setItem("hospital", hospital.uuid)
    : sessionStorage.removeItem("hospital");
  hospital.name
    ? sessionStorage.setItem("hospitalName", hospital.name)
    : sessionStorage.removeItem("hospitalName");
  hospital.permissions
    ? sessionStorage.setItem("permissions", hospital.permissions.join(","))
    : sessionStorage.removeItem("permissions");

  localStorage.removeItem("hospital");
  localStorage.removeItem("hospitalName");
  localStorage.removeItem("permissions");
}

export function getActiveHospitalStorage(): IActiveHospital | undefined {
  const json = sessionStorage.getItem("h") ?? localStorage.getItem("h");
  if (json) {
    localStorage.removeItem("h");
  }

  if (!json) {
    return undefined;
  }

  try {
      return JSON.parse(json) ?? undefined;
    } catch {
      return undefined;
    }
}

export const getLastHospitalSelected = async () => {
  const { data } = await api.get<{
    data: {
      data: {
        id: string;
        uuid: string;
        name: string;
        permissions?: number[];
        isProcedenciaActive: boolean;
        user: IUser;
      };
    };
  }>(`users/hospital-activity`);
  return data.data.data;
};
